import React, {FC, ReactNode} from 'react';

const style = {
	contentContainer: `flex flex-col   p-1 recommended:p-4`,
};

type ContentProps = {
	children?: ReactNode;
};

export const Content: FC<ContentProps> = ({children}) => {
	return <div className={style.contentContainer}>{children}</div>;
};

export default Content;
